import React from 'react';
import { Box } from '@mui/material';
import { QRCodeSVG } from 'qrcode.react';
import { useTranslation } from 'react-i18next';
import { finMarkDataUri } from '../brand/FinMark';
import { Container, TelegramCta } from './primitives';
import { BOT_URL, dotsBackground, landing } from './tokens';

const FinalCta: React.FC = () => {
  const { t } = useTranslation('landing');
  return (
    <Box component='section' aria-label={t('finalCta.title')} sx={{ pb: { xs: 9, md: 13 } }}>
      <Container>
        <Box
          sx={{
            ...dotsBackground,
            bgcolor: landing.surface,
            borderRadius: '32px',
            border: `1px solid ${landing.line}`,
            p: 'clamp(32px, 5vw, 64px)',
            display: 'flex',
            flexWrap: 'wrap',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: 5,
          }}
        >
          <Box
            sx={{
              flex: '1 1 440px',
              minWidth: 0,
              display: 'flex',
              flexDirection: 'column',
              gap: 2.5,
              alignItems: 'flex-start',
            }}
          >
            <Box
              component='h2'
              sx={{
                fontSize: 'clamp(48px, 6vw, 80px)',
                lineHeight: 0.96,
                letterSpacing: '-0.04em',
                fontWeight: 750,
              }}
            >
              {t('finalCta.title')}
            </Box>
            <Box
              component='p'
              sx={{ fontSize: 19, lineHeight: 1.55, color: landing.ink2, maxWidth: 480 }}
            >
              {t('finalCta.text')}
            </Box>
            <TelegramCta
              label={t('finalCta.cta')}
              sx={{ minHeight: 56, boxShadow: landing.shadow }}
            />
          </Box>

          {/* On a phone the button already opens Telegram; the code is for desktop. */}
          <Box
            sx={{
              display: { xs: 'none', md: 'flex' },
              flexDirection: 'column',
              alignItems: 'center',
              gap: 1.25,
            }}
          >
            <Box
              sx={{
                p: 1.5,
                borderRadius: '22px',
                bgcolor: '#FFFFFF',
                border: `1px solid ${landing.line}`,
                boxShadow: landing.shadow,
                lineHeight: 0,
              }}
            >
              <QRCodeSVG
                value={BOT_URL}
                size={164}
                level='H'
                fgColor={landing.ink}
                title={t('finalCta.qrLabel')}
                imageSettings={{ src: finMarkDataUri, height: 34, width: 34, excavate: true }}
              />
            </Box>
            <Box component='span' sx={{ fontSize: 13, color: landing.ink3 }}>
              {t('finalCta.qrHint')}
            </Box>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default FinalCta;
